import { handleImageInput, withSBErrorHandling, } from '../types';
import { ScanbotSDKPlugin } from './Definitions';
/**
 * @internal
 * @hidden
 */
export const ScanbotPdfGeneratorImpl = {
    async generateFromImages(params) {
        return withSBErrorHandling(async () => {
            return (await ScanbotSDKPlugin.generatePdfFromImages(Object.assign(Object.assign({}, params), { images: handleImageInput(params.images) }))).result;
        });
    },
    async generateFromDocument(params) {
        return withSBErrorHandling(async () => {
            return (await ScanbotSDKPlugin.generatePdfFromDocument(params)).result;
        });
    },
};
//# sourceMappingURL=PdfGeneratorImpl.js.map